import type { ComponentProps } from "react"

export default function EnergyRatingA(
  props: ComponentProps<"svg"> & { fill?: string },
) {
  const { fill = "currentColor", ...svgProps } = props

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        d="M23.3456 9.36055L23.3455 9.36043L13.3446 0.509095C12.9773 0.181611 12.4973 -2.25237e-05 11.9992 2.09495e-09C11.5011 2.25279e-05 11.0211 0.1817 10.6538 0.509216L0.654541 9.36043C0.448577 9.54309 0.283993 9.76554 0.171293 10.0136C0.0585935 10.2616 0.000254481 10.5298 0 10.8011V22.0529C0.000606423 22.5691 0.211515 23.064 0.586456 23.4291C0.961398 23.7941 1.46975 23.9994 2 24H22C22.5302 23.9994 23.0386 23.7941 23.4135 23.4291C23.7885 23.064 23.9994 22.5691 24 22.0529V10.8011C23.9997 10.5299 23.9414 10.2617 23.8287 10.0137C23.7161 9.76566 23.5515 9.54321 23.3456 9.36055Z"
        fill={fill}
      />
      <path
        className="rating"
        d="M8.853 20H6.603L10.6996 8.36365H13.3019L17.4041 20H15.1541L12.0462 10.75H11.9553L8.853 20ZM8.92686 15.4375H15.0632V17.1307H8.92686V15.4375Z"
        fill="white"
      />
    </svg>
  )
}
